export interface BannerAttrs {
  'body-text': string;
  'header-text': string;
  theme: string;
  icon: string;
  cta: CallToAction;
  size: BannerSize;
}

export interface CallToAction {
  actionName: string;
  autoDismiss?: boolean;
  href?: string;
  icon?: string;
  text: string;
  theme?: string;
  trackEventName?: string;
  trackProps?: {[prop: string]: string};
  value?: any;
}

export enum BannerTheme {
  Error = `error`,
  Info = `info`,
  Success = `success`,
  Warn = `warn`,
}

export enum BannerSize {
  Small = `small`,
  Large = `large`,
}
